module.exports = __webpack_public_path__ + "static/media/user-inverted.3f55e88c.svg";